
import { defineComponent, onBeforeMount, computed } from 'vue'
import { useRoute } from 'vue-router'

import Tabs from '@/common/components/UI/Tabs/index.vue'

// types
import { TabT } from '@/core/types/components.types'

// composable
import useAccount from '@/common/composable/useAccount'

export default defineComponent({
    components: {
        tabs: Tabs,
    },
    setup() {
        const { havePermissions } = useAccount()

        const tabs: TabT[] = [
            { id: 1, name: 'Подписанные', path: '/contracts' },
            { id: 2, name: 'На согласовании', path: '/contracts/to-be-agreed' },
        ]

        const setTabs = () => {
            if (havePermissions(['contract-register-index', 'all-root-permission'])) {
                tabs.splice(1, 0, {
                    id: 3,
                    name: 'Реестр договоров',
                    path: '/contracts/register',
                })
            }

            if (havePermissions(['contract-contract-archive', 'all-root-permission'])) {
                tabs.push({
                    id: 3,
                    name: 'Архив Договор24',
                    path: '/contracts/archive',
                })
            }
        }

        const route = useRoute()

        const isContracts = computed(() => {
            return !route.path.includes('templates') && !route.path.includes('bids') && !route.path.includes('settings')
        })

        onBeforeMount(setTabs)

        return { tabs, route, isContracts }
    },
})
